var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.491 2.02a.81.81 0 0 0-.472.492.93.93 0 0 0 .047.523c.038.076 1.252 1.306 4.48 4.537l4.43 4.432-4.43 4.432c-3.117 3.119-4.444 4.462-4.482 4.536-.046.087-.055.138-.055.323 0 .252.039.35.197.509.158.158.257.196.508.196.185 0 .236-.009.324-.054.073-.038 1.416-1.366 4.535-4.484l4.432-4.43 4.431 4.43c3.12 3.118 4.462 4.446 4.536 4.484.087.045.138.054.323.054.252 0 .35-.038.509-.196.158-.159.196-.257.196-.509 0-.185-.009-.236-.054-.323-.038-.074-1.366-1.417-4.483-4.536l-4.43-4.432 4.43-4.432c3.117-3.12 4.445-4.463 4.483-4.536.045-.088.054-.139.054-.324 0-.252-.038-.35-.196-.509-.159-.158-.257-.196-.509-.196-.185 0-.236.009-.323.054-.074.038-1.417 1.366-4.536 4.484l-4.431 4.43-4.432-4.43C4.36 3.334 3.113 2.101 3.038 2.063a1.03 1.03 0 0 0-.547-.044",
    clipRule: "evenodd"
  })));
};
export default SvgClose;